module.exports = __webpack_public_path__ + "img/plataforma.ccf21465.png";